export const text = {
  categoryUpdated: 'Se actualizó la categoría.',
  categoryUpdatedError:
    'No se pudieron guardar los cambios. Por favor inténtalo de nuevo.'
};
